// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import O1HD from "../../../../../engines/gameEngine";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import { NormalBackpackI } from "../../../manager/DefineInterface";
import NormalGameManager from "../../../manager/NormalGameManager";
import SettleLawsuitResultLayer from "./SettleLawsuitResultLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettleLawsuitSuccessLayer extends SettleLawsuitResultLayer {

	@property({ type: cc.Label, displayName:'' })
	labelPropName: cc.Label = null;

	@property({ type: cc.Sprite, displayName:'' })
	sprProp: cc.Sprite = null;

	@property({ type: cc.Node, displayName:'' })
	nodeAward: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeProp: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeBtn: cc.Node = null;

    private goodsId = 0;
    private goodsNum = 0;
    private itemConfig: NormalBackpackI = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    initShow () {
        this.labelGold.string = '+0';
        this.labelReputation.string = '+0';
    }

    showProp(visible: boolean) {
        this.nodeProp.active = visible;
        this.nodeBtn.active = visible;
    }

    setPropData(id: number, num: number) {
        let goodsId = this.goodsId = id;
        let goodsNum = this.goodsNum = num;
        NormalGameManager._instance.onPushGoods(goodsId, goodsNum);
        let itemConfig = this.itemConfig = backPackEventMap()[goodsId];
        this.labelPropName.string = itemConfig.name + 'x' + goodsNum;
        this.loadGoodsIcon(itemConfig.spPath);
    }

    async loadGoodsIcon(spPath: string) {
        if(spPath && spPath != ""){
            let bundle = await getOneBundle( BUNDLE_SMALL_NAME.backPackGameBundle );
            bundle.load(
                `backpackAssets/objSp/${spPath}`
                , cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>
                {
                    if(err){
                        console.log("加载背包图片失败",err);
                    }else{
                        if(this.sprProp && this.sprProp.isValid){
                            this.sprProp.spriteFrame = spr;
                        }
                    }
                }
            );
        }
    }

    onClickOpen() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.onClickClose();
        NormalGameManager._instance.onOutGoods(this.goodsId, this.goodsNum);
        NormalGameManager._instance.backpackManager.checkVaildUseOrGiveRule(this.itemConfig, null);
    }

    onClickPUshPacksack() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.onClickClose();
    }

    // update (dt) {}
}
